export default (state = [], action) => {
  switch (action.type) {
    case 'SET_CLICKS':
      return action.clicks
    default:
      return state
  }
}
